/**
 * Created by Yangxunwu on 2018/6/7.
 */

import upload from '@/utils/upload'
import request from '@/utils/request'

/**
 * 上传工资条
 * @param formData
 */
export function uploadSalaryRecord(formData) {

    return upload({
        url: '/salary/salary/upload',
        method: 'POST',
        data: formData,
    })
}

/**
 * 请求工资条记录数据
 * @param recordId
 */
export function getSalaryRecordDetail(recordId) {

    return request({
        url: '/salary/salary/record-detail',
        method: 'GET',
        params: { 'recordId': recordId }
    })
}

/**
 * 设置工资记录字段配置
 * @param data
 */
export function configSalaryRecordField(data) {

    return request({
        url: '/salary/salary/config-field',
        method: 'POST',
        data,
    })
}

/**
 * 请求预览工资条记录数据，去除了隐藏字段
 * @param recordId
 */
export function getPreviewSalaryDetail(recordId) {

	return request({
		url: '/salary/salary/preview-record-detail',
		method: 'GET',
		params: { 'recordId': recordId }
	})
}


/**
 * 发送工资条数据
 * @param data
 */
export function send(data) {

	return request({
		url: '/salary/salary/send',
		method: 'POST',
		data,
	})

}


// WEBPACK FOOTER //
// ./src/api/salary.js